import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { WifiOff } from "lucide-react";

export function OfflineBanner() {
  const { t } = useTranslation("common");
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[99998] flex items-center justify-center gap-2 bg-red-500/90 px-4 py-1.5 text-white text-[12px] font-medium backdrop-blur-sm pt-[max(0.375rem,env(safe-area-inset-top))]">
      <WifiOff className="w-3.5 h-3.5" />
      {t("offline", "Offline")}
    </div>
  );
}
